import { Component, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-ai-banner',
  templateUrl: './ai-banner-component.html',
  styleUrl: './ai-banner-component.scss',
})
export class AiBannerComponent {
  constructor(private dialogRef: MatDialogRef<AiBannerComponent>) {}

  onContactUsClick() {
    window.open('https://www.yukka.ai/contact-us', '_blank');
    this.dialogRef.close();
  }

  onUnderstand() {
    this.dialogRef.close();
  }
}
